import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=12ae6cfc&scoped=true&"
import script from "./SingleImage.vue?vue&type=script&lang=ts&"
export * from "./SingleImage.vue?vue&type=script&lang=ts&"
import style0 from "./SingleImage.vue?vue&type=style&index=0&id=12ae6cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae6cfc",
  null
  
)

export default component.exports